import { render, staticRenderFns } from "./subTab.vue?vue&type=template&id=23c7b622&scoped=true"
import script from "./subTab.vue?vue&type=script&lang=js"
export * from "./subTab.vue?vue&type=script&lang=js"
import style0 from "./subTab.vue?vue&type=style&index=0&id=23c7b622&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c7b622",
  null
  
)

export default component.exports